import { useHelpers as useHelpersRM } from '@remirror/react';
import type { TranscriptExtensions } from '@/components/Transcript/interfaces.extension.remirror';

export const useHelpers = () => {
  const helpers = useHelpersRM<TranscriptExtensions>();

  return helpers;
};